import { QueryClient } from '@tanstack/react-query';

import { ErroDaApi } from '../api/erros';

/**
 * Retry decidido pelo TIPO de erro, não por contagem cega.
 *
 * Repetir um 404 ou um 422 três vezes não conserta nada e ainda atrasa a
 * mensagem de erro que a pessoa precisa ler para agir.
 */
export function criarClienteDeQuery(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: (tentativa, erro) => {
          if (erro instanceof ErroDaApi && !erro.vaiAdiantarTentarDeNovo) return false;
          return tentativa < 2;
        },
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        // Sem isto, um erro de rede some do estado assim que o cache
        // entrega dado velho — e a tela mente que está tudo bem.
        throwOnError: false,
      },
      mutations: { retry: false },
    },
  });
}
